/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Promo_Movement_From_SelfInputs */



/**
* | output |
* | --- |
* | "Yourself ({name}) — pick a member to record from someone else's stock." |
*
* @param {Promo_Movement_From_SelfInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_from_self = /** @type {((inputs: Promo_Movement_From_SelfInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_From_SelfInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Vous-même (${i?.name}) — choisissez un membre pour enregistrer depuis le stock de quelqu'un d'autre.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Usted mismo (${i?.name}) — elija un miembro para registrar desde el stock de otra persona.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Você mesmo (${i?.name}) — escolha um membro para registrar a partir do estoque de outra pessoa.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Tu stesso (${i?.name}) — scegli un membro per registrare dallo stock di qualcun altro.`)
	return /** @type {LocalizedString} */ (`Yourself (${i?.name}) — pick a member to record from someone else's stock.`)
});